import { css } from 'styled-components';
export const PopconfirmStyles = css`
  .ant-popover-message > .anticon {
    top: 8px;
  }
  .ant-popconfirm {
    max-width: 300px;
  }
  .ant-popconfirm .ant-popover-inner-content {
    padding: 0px;
  }
  .ant-popconfirm .ant-popover-inner {
    padding: var(--spacing-05) 0px var(--spacing-03) 0px;
  }
  .ant-popconfirm .ant-popover-message {
    padding: 0px var(--spacing-05) var(--spacing-06);
  }
  .ant-popconfirm .ant-popover-message-title {
    padding: 0px;
  }
  .ant-popconfirm .ant-popover-buttons {
    display: flex;
    justify-content: center;
    gap: var(--spacing-02);
    flex-wrap: nowrap;
  }

  .ant-popconfirm .ant-popover-buttons .ant-btn {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;
